// Profile photos for Grant Callaghan
const PROFILE_PHOTOS = [
  '/img/articles/authors/Grant/grant-profile.png',
];

// Profile photos for Francis Callaghan  
const FRANCIS_PHOTOS = [
  '/img/articles/authors/Francis/francis-profile.png'
];

// Session-based random seed for consistency
let sessionSeed: number | null = null;

// Simple seeded random function
function seededRandom(seed: number): number {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

// Get a random profile photo with session consistency
export function getRandomGrantProfile(): string {
  if (sessionSeed === null) {
    sessionSeed = Date.now() + Math.random();
  }
  
  const randomIndex = Math.floor(seededRandom(sessionSeed) * PROFILE_PHOTOS.length);
  return PROFILE_PHOTOS[randomIndex];
}

// For specific use cases where you want a different photo
export function getRandomGrantProfileWithSeed(seed: string): string {
  const numericSeed = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const randomIndex = Math.floor(seededRandom(numericSeed) * PROFILE_PHOTOS.length);
  return PROFILE_PHOTOS[randomIndex];
}

// Get a random Francis profile photo with seed
export function getRandomFrancisProfile(): string {
  if (sessionSeed === null) {
    sessionSeed = Date.now() + Math.random();
  }
  
  const randomIndex = Math.floor(seededRandom(sessionSeed + 1000) * FRANCIS_PHOTOS.length);
  return FRANCIS_PHOTOS[randomIndex];
}

// For specific Francis photos per article
export function getRandomFrancisProfileWithSeed(seed: string): string {
  const numericSeed = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const randomIndex = Math.floor(seededRandom(numericSeed) * FRANCIS_PHOTOS.length);
  return FRANCIS_PHOTOS[randomIndex];
}